import { ApiHelper } from '..';

export const useApi = () => {
	let apiHelper = new ApiHelper();
	return { apiHelper, activeApi: apiHelper.active() };
};
